import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';

/** 404 页面，替代平台的 NotFoundRender */
export const NotFoundRender: React.FC = () => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
    <p className="text-5xl font-semibold text-muted-foreground">404</p>
    <h1 className="text-lg font-semibold text-foreground">页面不存在</h1>
    <p className="text-sm text-muted-foreground">
      地址可能已经变更，或者你没有访问这个页面的权限。
    </p>
    <Button asChild variant="outline">
      <Link to="/">回到首页</Link>
    </Button>
  </div>
);

export default NotFoundRender;
